<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 
    import ToolTip from '../components/ToolTip.svelte'; 

    let isLoading = false;
    let sku = "";
    let date_start = '';
    let date_end = '';
    let logs = [];
    


    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }

        getLogs();
       
    })


    const getLogs = async() => {

        isLoading = true;
        let postData = {};

        postData.action = 'crm_integration_logs';
        postData.token = $UserStore.data
        let response = await fetchData(postData);
        if (response.data) {
            logs = response.data
        }
        isLoading = false;

    }


    const handleProducts = async() => {

        isLoading = true;
        let postData = {};

        postData.action = 'crm_integration_products';
        postData.token = $UserStore.data
        postData.date_end = date_end
        postData.date_start = date_start;
        postData.sku = sku

        let response = await fetchData(postData);
        if (response.data) {

        }
        isLoading = false;

    }

    const handleStock = async() => {

        isLoading = true;
        let postData = {};

        postData.action = 'crm_integration_stocks';
        postData.token = $UserStore.data
        postData.date_end = date_end
        postData.date_start = date_start;
        postData.sku = sku

        let response = await fetchData(postData);
        if (response.data) {

        }
        isLoading = false;

    }



    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <h1 class="text-[20px] font-bold">{$_('integration.title')}</h1>        
            <div class="shipment-flex mb-[50px]">

                <div class="pt-4 font-bold">{$_('integration.products')}</div>
                <div class="input_box items-end">                    
                    <div class="input_con">
                        <label>{$_('integration.sku')}</label>
                        <input type="text" bind:value={sku}>
                    </div>
                    <div class="input_con">
                        <label>{$_('integration.date_start')}</label>
                        <input type="date" bind:value={date_start}>
                    </div>      
                    <div class="input_con">
                        <label> {$_('integration.date_end')}</label>
                        <input type="date" bind:value={date_end}>
                    </div>
                    <div>
                        <div class="create_button justify-center" on:click={ handleProducts }>{$_('integration.run')}</div>
                    </div>
                </div>

                <div class="pt-4 font-bold">{$_('integration.stock')}</div>
                <div class="input_box items-end">                    
                    <div class="input_con">
                        <label>{$_('integration.sku')}</label>
                        <input type="text" bind:value={sku}>
                    </div>
                    <div class="input_con">
                        <label>{$_('integration.date_start')}</label>
                        <input type="date" bind:value={date_start}>
                    </div>      
                    <div class="input_con">
                        <label> {$_('integration.date_end')}</label>
                        <input type="date" bind:value={date_end}>
                    </div>
                    <div>
                        <div class="create_button justify-center" on:click={ handleStock }>{$_('integration.run')}</div>
                    </div>
                </div>


                <div class="pt-4 font-bold">{$_('integration.log')}</div>
                <div class="w-full border-[1px] border-gray-300 rounded-[5px] p-5">
                    <table class="w-full text-[12px]">
                        {#each logs as log} 
                            <tr>
                                <td class="w-[150px]">{log.date}</td>
                                <td class="ltr">{log.msg}</td>
                                <td class="ltr">{log.response}</td>
                            </tr>
                        {/each}
                    </table>                
                </div>

                

            </div> 
  

        </div>
        
    </div>
</div>

